import lion from '../../../res/lion.png';
import rabbit from '../../../res/rabbit.png';
import cat from '../../../res/cat.png';
import crocodile from '../../../res/crocodile.png';
import dog from '../../../res/dog.png';
import flamingo from '../../../res/flamingo.png';
import panda from '../../../res/panda.png';
import owl from '../../../res/owl.png';

export const pictures = [
    {
        src: lion,
       name: 'Lion',
    },

    {
        src: rabbit,
        name: 'Lapin',
    },

    {
        src:cat,
        name: 'Chat',
    },

    {
        src: crocodile,
        name: 'Crocodile',
    },
    
    {
        src: dog,
        name: 'Chien',
    },

    {
        src: flamingo,
        name: 'Flamand rose',
    },

    {
       src: panda,
        name: 'Panda',
    },

    {
        src: owl,
        name: 'Hiboux',
    }
];